import React from 'react'
import { SHr, SLoad, SNavigation, SNotification, SPage, SText, STheme, SView } from 'servisofts-component2'
import Container from '../../Components/Container';
import Verified_icon from '../../Assets/verified_icon.svg';
import Camera_icon from '../../Assets/camera_icon.svg';
import Iten_check from './Components/Iten_check';
import MDL from '../../MDL';
import { ScrollView } from 'react-native-gesture-handler';
import { Animated, Easing, Keyboard, Platform } from 'react-native';
const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

export default class ChecklistQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.questionsScrollRef = null;
        this.questionsViewportHeight = 0;
        this.rowLayouts = {};
        this.lastScrollY = 0;
        this.scrollBeforeFocus = null;
        this.restoreOnInputExit = false;
        this.hideRestoreTimeout = null;
        this.scrollAnimationValue = new Animated.Value(0);
        this.scrollAnimationListener = null;
        this.checklistIdBackup = null;
        this.state = {
            loading: true,
            error: null,
            preguntas: [],
            checks: {},
            numbers: {},
            selects: {},
            checklist_id: "",
            tipo_vehiculo_id: "1",
            expedicion_id: null,
            keyboardHeight: 0,
        };
    }

    getPreguntaTipoVehiculoId = (item) => {
        const value = item?.lTipoVehiculo_id ?? item?.tipo_vehiculo_id ?? item?.tipoVehiculoId ?? item?.l_tipo_vehiculo_id ?? item?.vehiculo_tipo_id ?? item?.lTipoVehiculoId;
        const normalized = String(value ?? '').trim();
        return normalized.length > 0 ? normalized : null;
    }

    filtrarPreguntasPorTipoVehiculo = (preguntas, tipoVehiculoId) => {
        const rows = Array.isArray(preguntas) ? preguntas : [];
        const tipoObjetivo = String(tipoVehiculoId ?? '').trim();
        if (!tipoObjetivo) return rows;
        const filtradas = rows.filter((item) => {
            const tipoPregunta = this.getPreguntaTipoVehiculoId(item);
            return tipoPregunta === tipoObjetivo;
        });
        const hayTipoEnPreguntas = rows.some((item) => this.getPreguntaTipoVehiculoId(item) !== null);
        if (!hayTipoEnPreguntas) return rows;
        return filtradas;
    }


    checklist_id = SNavigation.getParam("id", "");
    tipo_vehiculo_id = SNavigation.getParam("tipo_vehiculo_id", "1");
    expedicion_id = SNavigation.getParam("expedicion_id", null);
    es
    async componentDidMount() {
        this.scrollAnimationListener = this.scrollAnimationValue.addListener(({ value }) => {
            this.questionsScrollRef?.scrollTo?.({ x: 0, y: value, animated: false });
        });
        this.keyboardWillShowSub = Keyboard.addListener('keyboardWillShow', this.onKeyboardShow);
        this.keyboardDidShowSub = Keyboard.addListener('keyboardDidShow', this.onKeyboardShow);
        this.keyboardDidHideSub = Keyboard.addListener('keyboardDidHide', this.onKeyboardHide);
        try {
            let checklist_id = this.checklist_id;
            if (!checklist_id) {
                checklist_id = generateUUID();
                console.log("✅ Nuevo checklist_id generado:", checklist_id);
            } else {
                console.log("✅ checklist_id capturado:", checklist_id);
            }
            console.log("%c" + checklist_id, `color: #ce0cff; font-weight: bold;`);
            this.checklistIdBackup = checklist_id;
            const tipo_vehiculo_id = String(this.tipo_vehiculo_id || "1").trim() || "1";
            const expedicion_id = this.expedicion_id;
            const preguntasRaw = await MDL.checklist.getChecklistPregunta();
            const preguntas = this.filtrarPreguntasPorTipoVehiculo(preguntasRaw, tipo_vehiculo_id);
            this.setState({ checklist_id, tipo_vehiculo_id, expedicion_id, preguntas: Array.isArray(preguntas) ? preguntas : [], loading: false, });
        } catch (error) {
            this.setState({ loading: false, error: error?.message || String(error), });
        }
    }

    // async componentDidUpdate(prevProps, prevState) {
    //     const newTipoVehiculo = String(SNavigation.getParam("tipo_vehiculo_id", "1") || "1").trim() || "1";
    //     const newExpedicionId = SNavigation.getParam("expedicion_id", null);
    //     if (
    //         newTipoVehiculo !== this.state.tipo_vehiculo_id ||
    //         newExpedicionId !== this.state.expedicion_id ||
    //     ) {
    //         console.log("🔄 Parámetros de navegación cambiaron, recargando preguntas...");
    //         console.log(`Anterior: tipo_vehiculo_id=${this.state.tipo_vehiculo_id}, expedicion_id=${this.state.expedicion_id}, es_tractora=${this.state.es_tractora}`);
    //         console.log(`Nuevo: tipo_vehiculo_id=${newTipoVehiculo}, expedicion_id=${newExpedicionId}, es_tractora=${newEsTractora}`);
    //         try {
    //             const preguntasRaw = await MDL.checklist.getChecklistPregunta();
    //             const preguntas = this.filtrarPreguntasPorTipoVehiculo(preguntasRaw, newTipoVehiculo);
    //             this.setState({
    //                 tipo_vehiculo_id: newTipoVehiculo,
    //                 expedicion_id: newExpedicionId,
    //                 preguntas: Array.isArray(preguntas) ? preguntas : [],
    //                 checks: {},
    //                 numbers: {},
    //                 selects: {},
    //             });
    //         } catch (error) {
    //             console.error("❌ Error al recargar preguntas:", error);
    //             this.setState({
    //                 error: error?.message || String(error),
    //             });
    //         }
    //     }
    // }

    componentWillUnmount() {
        this.keyboardWillShowSub?.remove?.();
        this.keyboardDidShowSub?.remove?.();
        this.keyboardDidHideSub?.remove?.();
        if (this.scrollAnimationListener) {
            this.scrollAnimationValue.removeListener(this.scrollAnimationListener);
            this.scrollAnimationListener = null;
        }
        this.scrollAnimationValue.stopAnimation();
        if (this.hideRestoreTimeout) {
            clearTimeout(this.hideRestoreTimeout);
            this.hideRestoreTimeout = null;
        }
    }

    animateScrollTo = (toY, duration = 420) => {
        const safeY = Math.max(0, toY);
        this.scrollAnimationValue.stopAnimation();
        this.scrollAnimationValue.setValue(this.lastScrollY);
        Animated.timing(this.scrollAnimationValue, {
            toValue: safeY,
            duration,
            easing: Easing.bezier(0.22, 0.61, 0.36, 1),
            useNativeDriver: false,
        }).start();
    }

    restoreScrollAfterInput = () => {
        if (Platform.OS === 'web') {
            this.scrollBeforeFocus = null;
            this.restoreOnInputExit = false;
            return;
        }
        if (!this.restoreOnInputExit) {
            this.scrollBeforeFocus = null;
            return;
        }
        if (this.scrollBeforeFocus === null) return;
        const restoreY = Math.max(0, this.scrollBeforeFocus);
        this.animateScrollTo(restoreY, 460);
        this.scrollBeforeFocus = null;
        this.restoreOnInputExit = false;
    }

    onKeyboardShow = (event) => {
        const keyboardHeight = event?.endCoordinates?.height ?? 0;
        this.setState({ keyboardHeight });
    }

    onKeyboardHide = () => {
        this.setState({ keyboardHeight: 0 });
        if (this.scrollBeforeFocus !== null) {
            if (this.hideRestoreTimeout) clearTimeout(this.hideRestoreTimeout);
            this.hideRestoreTimeout = setTimeout(() => {
                this.restoreScrollAfterInput();
                this.hideRestoreTimeout = null;
            }, 60);
        }
    }

    handleNumberInputBlur = () => {
        if (this.hideRestoreTimeout) {
            clearTimeout(this.hideRestoreTimeout);
            this.hideRestoreTimeout = null;
        }
        this.restoreScrollAfterInput();
    }

    handleNumberInputFocus = (rowKey, shouldRestoreOnExit = false) => {
        if (Platform.OS === 'web') {
            return;
        }
        setTimeout(() => {
            const layout = this.rowLayouts[rowKey];
            if (!layout) return;
            this.restoreOnInputExit = shouldRestoreOnExit;
            if (this.scrollBeforeFocus === null) {
                this.scrollBeforeFocus = this.lastScrollY;
            }
            const visibleHeight = Math.max(0, this.questionsViewportHeight - (this.state.keyboardHeight || 0));
            const targetTopOffset = visibleHeight * 0.8;
            const y = Math.max(0, layout.y - targetTopOffset);
            this.animateScrollTo(y, 400);
        }, 120);
    }

    normalizePregunta = (item, index) => {
        const key = String(item?.id ?? item?.key ?? item?.pk ?? index);
        const label = String(item?.pregunta ?? item?.descripcion ?? item?.detalle ?? item?.nombre ?? item?.title ?? `Pregunta ${index + 1}`);
        const tipoPregunta = String(item?.tipo_pregunta ?? '').trim();
        let type = 'check';
        let options = [];
        if (tipoPregunta === 'number') {
            type = 'number';
        } else if (tipoPregunta === 'check') {
            type = 'check';
        } else if (tipoPregunta === 'select') {
            type = 'select';
            options = item?.data ?? item?.options ?? item?.valores ?? [];
        } else {
            const rawType = String(item?.type ?? item?.tipo ?? item?.input_type ?? '').toLowerCase();
            type = rawType === 'number' || rawType === 'numeric' || rawType === 'int' ? 'number' : 'check';
        }
        return { key, label, type, options };
    }

    handlePickPhoto() {
        let { checklist_id } = this.state;
        if (!checklist_id && this.checklistIdBackup) {
            console.warn("⚠️ checklist_id vacío en handlePickPhoto, usando backup:", this.checklistIdBackup);
            checklist_id = this.checklistIdBackup;
        }

        if (!checklist_id) {
            console.error("❌ No se puede navegar sin checklist_id");
            SNotification.send({
                key: "checklist_error",
                title: "Error",
                body: "No se pudo obtener el ID del checklist",
                color: STheme.color.danger,
                time: 3000,
            });
            return;
        }
        this.clearAllFields();
        let checklist_idsssssssasas = String(this.checklist_id || "").trim();

        SNotification.send({
            key: "checklist_ok",
            title: "Checklist guardado",
            body: "Respuestas registradas correctamente.",
            color: STheme.color.success,
            time: 3000,
        });
        SNavigation.navigate('/check/ChecklistImageCollection', { id: checklist_idsssssssasas, tipo_vehiculo_id: this.tipo_vehiculo_id });
    }

    clearAllFields = () => {
        this.setState({
            checks: {},
            numbers: {},
            selects: {},
        });
    }

    logAllData = async () => {
        let { preguntas, checklist_id, tipo_vehiculo_id, expedicion_id, es_tractora } = this.state;
        if (!checklist_id && this.checklistIdBackup) {
            console.warn("⚠️ checklist_id vacío en logAllData, usando backup:", this.checklistIdBackup);
            checklist_id = this.checklistIdBackup;
        }

        const rows = (Array.isArray(preguntas) ? preguntas : []).map(this.normalizePregunta);
        if (!checklist_id) {
            console.error("❌ NO SE PUDO OBTENER checklist_id - Estado:", this.state, "Backup:", this.checklistIdBackup);
            throw new Error("El checklist_id es obligatorio pero no se pudo obtener");
        }
        // let checklist_idsssss = String(SNavigation.getParam("id", "") || "").trim();

        const respuestas = rows
            .map((item) => {
                const baseResponse = {
                    checklist_id: this.checklist_id,
                    checklist_pregunta_id: item.key,
                    respuesta: this.getRespuesta(item)
                };

                return baseResponse;
            });
        const postResponse = await Promise.all(
            respuestas.map((body) => MDL.checklist.postChecklistDetalle(body))
        );
        return postResponse;
    }

    toggleCheck(key, type) {
        this.setState(prev => {
            const current = prev.checks[key] ?? { cancel: false, confirm: false };
            const nextValue = !current[type];
            return {
                checks: {
                    ...prev.checks,
                    [key]: {
                        cancel: type === 'cancel' ? nextValue : false,
                        confirm: type === 'confirm' ? nextValue : false,
                    },
                }
            };
        });
    }

    getRespuesta = (item) => {
        if (item.type === 'number') {
            const value = this.state.numbers[item.key];
            return value && String(value).trim().length > 0 ? String(value) : '-';
        }
        if (item.type === 'select') {
            const value = this.state.selects[item.key];
            return value && String(value).trim().length > 0 ? String(value) : '-';
        }
        const val = this.state.checks[item.key] ?? { cancel: false, confirm: false };
        if (val.confirm) return 'SI';
        if (val.cancel) return 'NO';
        return '-';
    }

    normalizeNumberInput = (text) => {
        const normalized = String(text ?? '').replace(',', '.');
        const numericOnly = normalized.replace(/[^0-9.]/g, '');
        const parts = numericOnly.split('.');
        const integerPart = (parts[0] ?? '').slice(0, 5);
        const decimalPart = parts.slice(1).join('').slice(0, 2);
        return parts.length > 1
            ? `${integerPart || '0'}.${decimalPart}`
            : integerPart;
    }

    renderRow(item, isLastNumberInput) {
        const val = this.state.checks[item.key] ?? { cancel: false, confirm: false };
        return (
            <SView
                key={item.key}
                col={"xs-12"}
                onLayout={(event) => {
                    const { y, height } = event.nativeEvent.layout;
                    this.rowLayouts[item.key] = { y, height };
                }} >
                <Iten_check
                    type={item.type}
                    label={item.label}
                    options={item.options}
                    cancelActive={val.cancel}
                    confirmActive={val.confirm}
                    onCancel={() => this.toggleCheck(item.key, 'cancel')}
                    onConfirm={() => this.toggleCheck(item.key, 'confirm')}
                    value={this.state.numbers[item.key]}
                    selectedValue={this.state.selects[item.key]}
                    onChangeText={(text) => {
                        const safeValue = this.normalizeNumberInput(text);
                        this.setState(prev => ({ numbers: { ...prev.numbers, [item.key]: safeValue } }));
                    }}
                    onSelectChange={(value) => {
                        this.setState(prev => ({ selects: { ...prev.selects, [item.key]: value } }));
                    }}
                    onFocus={() => this.handleNumberInputFocus(item.key, isLastNumberInput)}
                    onBlur={this.handleNumberInputBlur}
                    onEndEditing={this.handleNumberInputBlur}
                />
                <SHr height={4} />
            </SView>
        );
    }

    render() {
        const { loading, error, preguntas, keyboardHeight } = this.state;
        const rows = preguntas.map(this.normalizePregunta);
        const lastNumberIndex = rows.reduce((acc, item, index) => {
            if (item.type === 'number') return index;
            return acc;
        }, -1);
        return (
            <SPage center disableScroll>
                <Container flex>
                    <SView col={"xs-12"} flex style={{ backgroundColor: STheme.color.card, padding: 24, borderRadius: 16, alignItems: "center", justifyContent: "space-between", }}>
                        <SView col={"xs-12"} center>
                            <SView col={"xs-12"} center style={{ alignItems: "center" }} row>
                                <Verified_icon width={18} height={18} fill={STheme.color.secondary} style={{ marginRight: 8 }} />
                                <SText font='AlbertSans' center fontSize={24} color={STheme.color.secondary}>TIEMPO DE CHECKLIST</SText>
                            </SView>
                            <SHr height={10} />
                            <SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
                            <SHr height={10} />
                            <SText font='AlbertSans' bold center fontSize={22} color={STheme.color.text}>Validación Datos</SText>
                            <SHr height={10} />
                        </SView>
                        <SView col={"xs-12"} flex style={{ minHeight: 0 }}>
                            <SHr height={4} />
                            <SView
                                col={"xs-12"}
                                flex
                                style={{ minHeight: 0 }}
                                onLayout={(event) => {
                                    this.questionsViewportHeight = event.nativeEvent.layout.height;
                                }} >
                                <ScrollView
                                    ref={(ref) => { this.questionsScrollRef = ref; }}
                                    style={{ flex: 1, width: '100%' }}
                                    onScroll={(event) => { this.lastScrollY = event?.nativeEvent?.contentOffset?.y ?? 0; }}
                                    scrollEventThrottle={16}
                                    contentContainerStyle={loading ? { flexGrow: 1, justifyContent: 'center', paddingBottom: keyboardHeight + 12 } : { paddingBottom: keyboardHeight + 100 }}
                                    keyboardShouldPersistTaps="handled"
                                    showsVerticalScrollIndicator >
                                    {loading ? (
                                        <SView col={"xs-12"} center style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <SLoad />
                                            <SHr height={10} />
                                            <SText center color={STheme.color.text}>Cargando preguntas...</SText>
                                        </SView>
                                    ) : null}
                                    {error ? <SText color={STheme.color.danger}>{error}</SText> : null}
                                    {!loading && !error && rows.length <= 0 ? <SText>No hay preguntas.</SText> : null}
                                    {!loading && !error ? rows.map((item, index) => this.renderRow(item, index === lastNumberIndex)) : null}
                                </ScrollView>
                            </SView>
                            <SHr height={20} />
                        </SView>
                        <SView col={"xs-12"} height={50} center style={{ borderRadius: 8, backgroundColor: STheme.color.secondary, justifyContent: 'center' }}
                            onPress={async () => {
                                try {
                                    await this.logAllData();
                                } catch {
                                    SNotification.send({
                                        key: "checklist_detalle_error",
                                        title: "No se pudo guardar",
                                        body: "Verifica tu conexion e intenta nuevamente.",
                                        color: STheme.color.danger,
                                        time: 3000,
                                    });
                                    return;
                                }
                                this.handlePickPhoto();
                            }}>
                            <SView col={"xs-12"} center style={{ alignItems: "center" }} row>
                                <Camera_icon width={40} height={29} style={{ marginRight: 8 }} />
                                <SText bold font='AlbertSans' center fontSize={20} color={STheme.color.primary}>Insertar Fotos</SText>
                            </SView>
                        </SView>
                    </SView>
                </Container>
                <SHr height={20} />
            </SPage>
        );
    }
}